import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["el"];

  click(e) {
    e.preventDefault();

    this.elTarget.click();
  }

  upload(event) {
    if (!event.target.files?.length) return;

    this.showUploading(event.target);
    this.elTarget.click();
  }

  showUploading(input) {
    const row = input.closest("li");
    if (!row) return;

    row.querySelector("[data-click-mapper-target='trigger']")?.classList.add("hidden");
    row.querySelector("[data-click-mapper-target='status']")?.classList.remove("hidden");
  }

  clickById(e) {
    e.preventDefault();

    if (e.params.id) {
      const el = document.getElementById(e.params.id);
      if (el) el.click();
    }
  }
}
